define('lib/Podio.UI.CreateSpaceModal',['require','translate','jquery','react','react-dom','underscore','lib/Podio.Transport.Space','lib/Podio.Router','lib/Podio.Routes','lib/Podio.UI.Modal','lib/Podio.UI','lib/Podio.Event.UI','lib/Podio.Event','lib/Podio.Utils','lib/Podio.FormValidation','lib/Podio.Config','lib/view_helpers/base','jst!address_book_export/_mail2workspace_howto','component!SpaceComposerModalComponent','controllers/address_book_export/Podio.Controllers.AddbookExport.Main'],function(require) {
  var t = require('translate');
  var $ = require('jquery');
  var React = require('react');
  var ReactDOM = require('react-dom');
  var _ = require('underscore');

  var transportSpace = require('lib/Podio.Transport.Space');
  var router = require('lib/Podio.Router');
  var routes = require('lib/Podio.Routes');
  var modal = require('lib/Podio.UI.Modal');
  var podioUI = require('lib/Podio.UI');
  var keyCodes = podioUI.KeyCodes;
  var eventUI = require('lib/Podio.Event.UI');
  var podioEvent = require('lib/Podio.Event');
  var podioUtils = require('lib/Podio.Utils');
  var formValidation = require('lib/Podio.FormValidation');
  var podioConfig = require('lib/Podio.Config');
  var viewHelpers = require('lib/view_helpers/base');
  var jstHowTo = require('jst!address_book_export/_mail2workspace_howto');

  var SpaceComposerModalComponent = React.createFactory(require('component!SpaceComposerModalComponent'));

    var modalWidth = 720, modalTitle, elmCreateSpaceModal, onSuccessCallBack;
    var creating = false;

    function onCreateSpaceSubmit(elmTarget, e) {
      if(! creating ) {
        creating = true;
        $('#edit-name-wrapper .error-failed').remove();
        var elmSubmitButton = $('#submit_new_space_button');
        podioUI.disableButtonWithLoader(elmSubmitButton);

        transportSpace.createSpace(elmCreateSpaceModal.find('form'), function(responseData) {
          if(responseData.status == 'ok') {
            onSuccessCallBack(responseData.data.space);
          } else {
            elmCreateSpaceModal.find('input[type=text]').last().after('<div class="error-failed">' + responseData.message + '</div>');
            podioUI.restoreButtonWithLoader(elmSubmitButton);
          }
        });
      }
    }

    function redirectToNewSpace(space) {
      location.href = space.url + '?new=true&show_invite=true#show_invite=true';
    }

    function onCreateSpaceClicked(elmTarget, e) {
      elmCreateSpaceModal.find('form').submit();
    }

    function onExistingNewOrgClicked(elmTarget, e) {
      var checked = $("input:radio[name='space[new_organization]']:checked").val();
      if(checked == 'true') {
        $('#existing_org_item').hide();
        $('#new_org_item').show();
      } else {
        $('#new_org_item').hide();
        $('#existing_org_item').show();
      }
    }

    function onCreateSpaceKeyUp(elmTarget, e) {
      if (e.keyCode == keyCodes.Return) {
        onCreateSpaceClicked(elmTarget, e);
      }
    }

    function show(options) {
      creating = false;
      modalTitle = options.title;
      onSuccessCallBack = options.callback || redirectToNewSpace;

      modal.showLoading(modalTitle, { width: modalWidth});

      transportSpace.getCreateSpaceModalLayout(options.newUrl, function(responseData) {


        if (responseData.status === 'error' && responseData.error_code === 'no_rights') {
          window.location.hash = 'organization/setup';
          return;
        }

        var content;
        if(podioUtils.isPresent(responseData.data.heading_html)) {
          content = $('<div/>').html('<h4>' + responseData.data.heading_html + '</h4>' + responseData.data.html);
        } else {
          content = responseData.data.html;
        }
        modal.show(content, { title: responseData.data.title_html, footerHtml: responseData.data.footer_html, breadcrumb: responseData.data.breadcrumb_html, hideHandler: onModalClose, width: modalWidth, height: 300 });

        if ($('.create-space-modal-with-access-settings').length > 0) {
          elmCreateSpaceModal = $('.create-space-modal-with-access-settings');
        }
        else {
          elmCreateSpaceModal = $('.create-space-modal');
        }
        setupCreateSpaceValiation();
        elmCreateSpaceModal.find('input[type=text]').focus();
      });
    }
    function onModalClose() {
      router.goToHashRoute('');

      return true;
    }

    function setupCreateSpaceValiation() {
      var elmCreateSpaceForm = elmCreateSpaceModal.find('form');

      formValidation.init(elmCreateSpaceForm, {
        rules: {
          'space[new_organization_name]': {
            required: function() {
              return ($("input:radio[name='space[new_organization]']:checked").val() == 'true');
            }
          }
        }
      });

    }

    function onModalInvoked(elmTarget, e) {
      var orgId = elmTarget.data('org-id');
      var share_id = elmTarget.data('shareId') ? elmTarget.data('shareId') : null;
      var options = orgId ? {'org_id': orgId} : {};
      if (share_id) {
        options.share_id = share_id;
      }

      if (_.isNumber(orgId)) {
        showSpaceComposerModal(orgId, share_id);
      } else {
        var newUrl = routes.new_space_path(options);
        show({
          newUrl: newUrl,
          title: t('Create a new space. #top_bar'),
          hideHandler: onModalClose
        });
      }
    }

    function showSpaceComposerModal(orgId, shareId) {
      var node = document.querySelector('.space-composer-modal-component-container');

      if (!_.isElement(node)) {
        node = document.createElement('div');
        node.className = 'space-composer-modal-component-container';

        document.body.appendChild(node);
      }

      var spaceComposerModalComponent = ReactDOM.render(SpaceComposerModalComponent({
        orgId: orgId,
        shareId: shareId
      }), node);

      spaceComposerModalComponent.open();
    }

    function showEmailToWorkspaceInstructionsModal(email) {
      modal.show('', {
        title: t('Learn how to use the email-to-workspace function #email-to-workspace'),
        className: 'email-to-workspace-hint-modal',
        width: 720,
        autoHeight: true
      });

      $('.email-to-workspace-hint-modal .modal-content').html(viewHelpers.render(jstHowTo, { email: email }));
    }

    function onEmailToWorkspaceClick(elmTarget, e) {
      e.stopPropagation();

      var controller = require('controllers/address_book_export/Podio.Controllers.AddbookExport.Main');
      var addressBookExportController = new controller({
        privateName: 'space',
        ref: {
          'type': 'org',
          'id':elmTarget.data('org-id')
        }
      });

      var mailsPromise = addressBookExportController.loadMails();
      mailsPromise.done(function() {
        showEmailToWorkspaceInstructionsModal(addressBookExportController.privateMail);
        modal.signals.afterModalClosed.addOnce(addressBookExportController.open);
      });
    }

    function onChangeAccess(elmTarget, e) {
      elmTarget.parents('.space-access-settings').find('.access-setting').removeClass('selected');
      elmTarget.parents('.access-setting').addClass('selected');
    }

    function onInit() {
      var hashQuery = router.getHashes();
      if (hashQuery['show_invite'] && hashQuery['show_invite'] == 'true') {
        var space_id = podioConfig.space_id;
        router.goToHashRoute('invite/{0}'.format(space_id));
      }
    }

    podioEvent.bind(podioEvent.Types.init, onInit);
    eventUI.bind('change', '#space_new_organization_true, #space_new_organization_false', onExistingNewOrgClicked);
    eventUI.bind('submit', '.create-space-modal form, .create-space-modal-with-access-settings form', onCreateSpaceSubmit);
    eventUI.bind('click', '#submit_new_space_button', onCreateSpaceClicked);
    eventUI.bind('click', '#email-to-workspace-trigger', onEmailToWorkspaceClick);
    eventUI.bind('keyup', '.create-space-modal form input[type=text], .create-space-modal-with-access-settings form input[type=text]', onCreateSpaceKeyUp);
    eventUI.bind('click', '.invoke-create-space-modal', onModalInvoked);
    eventUI.bind('change', '.space-access-settings input[type=radio]', onChangeAccess, true);

    return {
        show: show
    };

});

